import React, {useEffect} from 'react';
import {useDispatch, useSelector} from "react-redux";
import surveyData from '../../data/surveyData';
import {changeAddress, changeAnswer} from "../../modules/answers";
import Button from "@material-ui/core/Button";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import TextField from "@material-ui/core/TextField";
import DialogActions from "@material-ui/core/DialogActions";
import Dialog from "@material-ui/core/Dialog";
import SearchIcon from '@material-ui/icons/Search';
import Grid from "@material-ui/core/Grid";
import IconButton from "@material-ui/core/IconButton";
import Paper from "@material-ui/core/Paper";
import {makeStyles} from "@material-ui/core";
import AddrForm from "../common/AddrForm";
import List from "@material-ui/core/List";
import {initializeForm, searchAddress} from "../../modules/address";
import Container from "@material-ui/core/Container";
import ScrollableAnchor from "react-scrollable-anchor";
import {changeState, setSelectedItem} from "../../modules/menu";
import SentenceForm from "../common/SentenceForm";
import {useRecoilState, useSetRecoilState} from "recoil";
import {answerState, menuCheckSelector, selectedMenuItemState} from "../../state/globalState";

const useStyles = makeStyles(theme => ({
    root: {
        maxHeight: 550,
        overflowX: 'auto',
    },
    table: {
        minWidth: 650,
    },
    button: {
        marginTop: theme.spacing(3),
        marginLeft: theme.spacing(1),
        borderRadius: 15,
        backgroundColor: "#1b6817",
        padding: '5px 30px',
        height: 35,
        fontSize: "15px",
        color: 'white',
        '&:hover': {
            backgroundColor: '#767676',
            color: '#ffffff'
        }
    }
}));

const Address = (props) => {
    const [answer, setAnswer] = useRecoilState(answerState);
    const setSelectedMenuItem = useSetRecoilState(selectedMenuItemState);
    const setMenuCheck = useSetRecoilState(menuCheckSelector);
    const [keyword, setKeyword] = React.useState('');
    const [open, setOpen] = React.useState(false);
    const classes = useStyles();
    const dispatch = useDispatch();
    const address = useSelector(state => state.address);
    const bjdCd = useSelector(state => state.bjdCd);
    const sentences = surveyData[props.step].questions;
    const title = surveyData[props.step].title;
    const hide = surveyData[props.step].hide;
    const {selectItem} = props;
    const [roadAddr, setRoadAddr] = React.useState("");
    let parentCompRef = props.compRef;

    useEffect(() => {
        setRoadAddr(answer.roadAddr);
    }, [answer]);

    // 도로명주소 선택 이벤트 처리
    const handleOnSelect = (road, detail, base, zpcd, bjdCd) => {
        const newState = {
            ...answer,
            roadAddr: road,
            roadAddrDetail: answer.roadAddrDetail !== '' ? answer.roadAddrDetail : '',
            baseAddr: base,
            zpcd: zpcd,
            bjdCd: bjdCd
        }
        setAnswer(newState);

        setSelectedMenuItem('SURVEY_' + props.step);
        setMenuCheck(true);


        setOpen(false);

        setTimeout(function() {
            parentCompRef[props.step].focus();
        }, 500);
    };

    const handleInputAnswer = (val) => {
        if (val.length < 50) {
            const newState = {
                ...answer,
                roadAddrDetail: val,
            }
            setAnswer(newState);
        }
    };

    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            handleClickOpenDialog();
        }
    }

    const handleClickOpenDialog = async () => {
        dispatch(searchAddress(keyword));
    };

    const handleClickOpen = () => {
        setKeyword('');
        dispatch(initializeForm(null));
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
        dispatch(initializeForm(null));
    };

    const handleInputChange = (e) => {
        setKeyword(e.target.value);
    };

    const addRefs = (e) => {
        parentCompRef[props.step] = e;
    };

    return (
        <>
            <ScrollableAnchor id={props.step.toString()}>
            <div>
                <Container hidden={hide} style={{background: 'transparent', marginBottom: '10px'}}>
                <SentenceForm
                    title={title}
                    sentences={sentences}
                    selectItem={selectItem}
                    step={props.step}
                />
                <Grid container
                      alignItems='center'
                      style={{margin: '0 20px'}}>
                    <Grid item md={12} sm={12} xs={12}>
                        <Button
                            variant="contained"
                            className={classes.button}
                            onClick = {handleClickOpen}
                        >
                            주소검색
                        </Button>
                    </Grid>
                    <Grid item md={8} sm={8} xs={12} style={{marginRight: 30, marginTop: 10}}>
                        <TextField
                            required
                            key='addr_base'
                            label="도로명 주소"
                            fullWidth={true}
                            margin="none"
                            disabled={true}
                            value={roadAddr}
                        />
                    </Grid>
                    <Grid item md={3} sm={3} xs={12} style={{marginRight: 30, marginTop: 10}}>
                        <TextField
                            required
                            key='addr_detail'
                            label="상세 주소"
                            fullWidth={true}
                            margin="none"
                            inputRef={addRefs}
                            value={answer.roadAddrDetail}
                            onChange={(e) => handleInputAnswer(e.target.value)}
                        />
                    </Grid>
                </Grid>
                </Container>
            </div>
            </ScrollableAnchor>

            <Dialog open={open} onClose={handleClose} aria-labelledby="form-dialog-title"
                    fullWidth={true}
                    maxWidth='sm'>
                <DialogTitle id="form-dialog-title">도로명 주소 검색</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        도로명 주소를 입력하세요.
                    </DialogContentText>
                    <Grid container
                          alignItems='center'>
                        <Grid item md={11}>
                            <TextField
                                required
                                id="outlined-required"
                                label="도로명"
                                margin="normal"
                                fullWidth={true}
                                variant="outlined"
                                onChange={handleInputChange}
                                onKeyPress={handleKeyPress}
                                autoFocus={true}
                                value={keyword}
                            />
                        </Grid>
                        <Grid item md={1}>
                            <IconButton aria-label="search" onClick={handleClickOpenDialog}>
                                <SearchIcon />
                            </IconButton>
                        </Grid>
                    </Grid>

                    <Paper className={classes.root}>
                        <div>
                            {address.address && address.address.map((item, idx) =>  (
                                <AddrForm key={'ADDR_' + idx} roadAddr={item.roadAddr} roadAddrDetail={item.bdNm}
                                          jibun={item.jibunAddr} zpcd={item.zipNo} admCd={item.admCd} onItemClick={handleOnSelect} />
                            ))}
                            {!address.address && address.errorMessage && <p style={{color: 'red'}}>{address.errorMessage}</p>}
                        </div>
                    </Paper>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} color="primary">
                        닫기
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
};

export default Address;
